import { createApi } from "@reduxjs/toolkit/query/react";
import { IApiResponse, IPaginate } from "../../interfaces/common";
import { Ivendor } from "../../interfaces/vendor";
import { baseQuery } from "./common";
export const vendorApi = createApi({
  reducerPath: "vendors",
  baseQuery,
  tagTypes: ["Vendor"],
  refetchOnReconnect: true,

  endpoints: (builder) => ({

    getVendors: builder.query<
      IApiResponse<IPaginate<Ivendor[]>>,
      { pagination: { page: number; limit: number } }
    >({
      query: ({ pagination: { page = 1, limit = 10 } }) =>
        `/vendor?page=${page}&limit=${limit}`,
      providesTags: (result) =>
        result?.payload?.data
          ? [
            ...result.payload.data.map((vendor) => ({
              type: "Vendor" as const,
              id: vendor.id,
            })),
            { type: "Vendor", id: "LIST" },
          ]
          : [{ type: "Vendor", id: "LIST" }],
    }),

    getVendorBySearch: builder.query<
      IApiResponse<IPaginate<Ivendor[]>>,
      { pagination: { page: number; limit: number }; search: string }
    >({
      query: ({ pagination: { page = 1, limit = 10 }, search }) =>
        `/vendor/filter?name=${search}&page=${page}&limit=${limit}`,
      providesTags: (result) =>
        result?.payload?.data
          ? [
            ...result.payload.data.map((vendor) => ({
              type: "Vendor" as const,
              id: vendor.id,
            })),
            { type: "Vendor", id: "SEARCH_LIST" },
          ]
          : [{ type: "Vendor", id: "SEARCH_LIST" }],
    }),


    getVendorsById: builder.query<IApiResponse<Ivendor>, string>({
      query: (id) => `/vendor/${id}`,
      providesTags: (result, error, id) => [{ type: "Vendor", id }],
    }),


    addVendor: builder.mutation<Ivendor, Partial<Ivendor>>({
      query: (body) => ({
        url: `vendor`,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Vendor", id: "LIST" }],
    }),


    updateVendor: builder.mutation<Ivendor, Partial<Ivendor>>({
      query: ({ id, ...patch }) => ({
        url: `vendor/${id}`,
        method: "PATCH",
        body: patch,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Vendor", id },
        { type: "Vendor", id: "LIST" },
      ],
    }),


    deleteVendor: builder.mutation<Ivendor, string>({
      query: (id) => ({
        url: `vendor/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (_result, _error, id) => [
        { type: "Vendor", id },
        { type: "Vendor", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetVendorsQuery,
  useGetVendorBySearchQuery,
  useGetVendorsByIdQuery,
  useAddVendorMutation,
  useUpdateVendorMutation,
  useDeleteVendorMutation,

  useLazyGetVendorsQuery,
  useLazyGetVendorBySearchQuery,
  useLazyGetVendorsByIdQuery,
} = vendorApi;